export default [
  {
    title: "Fullfilment",
    customIcon: "FulfillmentSVG",
    children: [
      {
        title: "Products",
        route: "custom-module",
        path: "/custom-module/fulfillment",
      },
    ],
  },
];
